import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { useDispatch } from 'react-redux'
import { updateShowSideModal, updateUser } from './userSlice'
import { Avatar, Skeleton } from '@mui/material'
import UserService from '../../services/user'
import { error } from 'console'
import { handleRequestError } from '../../services/api'

export default function UserBox() {

    const dispatch = useDispatch()

    const user = useSelector((state: RootState) => state.user.details)

    const showUserSidebarModal = () => dispatch(updateShowSideModal(true))

    const [loading, setLoading] = useState<boolean>(false)

    const [attempt, setAttempt] = useState<number>(0)

    const loadUserDetails = () =>UserService.getCurrentUserData()
        .then(response => {
            dispatch(updateUser(response))
            setLoading(false)
            setAttempt(attempt + 1)
        })

    useEffect(() => {
        if (!user.id){
            setLoading(true)

            loadUserDetails()
                .catch(error => {

                    switch(error.response.status){

                        case 401:
                            if (attempt < 3){
                                loadUserDetails()
                                    .catch(error => {
                                        console.log("error", error)
                                    })
                            }else{
                                handleRequestError(error, dispatch)
                            }

                    }

                })

        }
    }, [user])

    if (loading){
        return <Skeleton style={{ borderRadius: "100%" }} variant="rounded" width={50} height={50} />
    }

    return <Avatar onClick={() => showUserSidebarModal()} className="header-user-avatar" alt={user.first_name} src={user.thumbnail ? user.thumbnail : ""}>{user.first_name.charAt(0)}</Avatar>
}